import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Message } from '../../../subcomponents/message/message';
export var MemberFilmWatchlistMessageType;
(function (MemberFilmWatchlistMessageType) {
    MemberFilmWatchlistMessageType["EmptyMemberFilmWatchlist"] = "EmptyMemberFilmWatchlist";
    MemberFilmWatchlistMessageType["FailedToLoadData"] = "FailedToLoadData";
})(MemberFilmWatchlistMessageType || (MemberFilmWatchlistMessageType = {}));
const b = bemClassBuilder('v-member-film-watchlist-message');
export const MemberFilmWatchlistMessage = observer(props => {
    const { messageType, displayText, assets, children } = props;
    return (_jsx(Message, Object.assign({}, getMemberFilmWatchlistMessageProps(messageType, assets, displayText), { className: b.block() }, { children: children })));
});
MemberFilmWatchlistMessage.displayName = 'MemberFilmWatchlistMessage';
const getMemberFilmWatchlistMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case MemberFilmWatchlistMessageType.EmptyMemberFilmWatchlist:
            return {
                iconName: assets.emptyWatchlistIconName,
                title: displayText.emptyWatchlistTitle
            };
        case MemberFilmWatchlistMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        default:
            return {
                iconName: assets.failedToLoadDataIconName
            };
    }
};
